import React, { useRef, useState, useContext, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Outlet } from 'react-router';
import { OnTheMenuDataContext } from '../../context-api/OnTheMenuDataProvider';
import { LoginDataContext } from '../../context-api/LoginDataProvider';
import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper';
import './StoreList.scss';
import { localStorageKeys } from '../../global/constants';
import PageBase from '../../composed/pagebase/pagebase';
import StoreListSkeleton from './StoreListSkeleton/StoreListSkeleton';
import { Error404 } from '../../composed/Error404/Error404';
import { API_NETWORK_ERROR } from '../../global/constants';
import StoreListTabs from './StoreListTabs';
import CelebrityChef from '../storelist/CelebrityChef/CelebrityChef';
import CelebrityChefMobile from './CelebrityChef/CelebrityChefMobile';
import CloudKitchenMobile from './CloudKitchen/CloudKitchenMobile';
import CloudKitchen from '../storelist/CloudKitchen/CloudKitchen';
import HomeChefsMobile from './HomeChef/HomeChefMobile';
import HomeChefs from './HomeChef/HomeChef';
import RestaurantsMobile from './Restaurant/RestaurantMobile';
import Restaurants from './Restaurant/Restaurant';
import CateringMobile from './Catering/CateringMobile';
import Catering from './Catering/Catering';
import Transition from './../../transition';
import ErrorCatchBlock404 from '../../composed/ErrorCatchBlock404/ErrorCatchBlock404';
import { GlobalStateDataContext } from '../../context-api/GlobalStateDataProvider';
import OrderTrackingLive from '../../composed/orderConfirmation/OrderTrackingLive';

const { ZIP_CODE, KITCHEN_NAMES } = localStorageKeys;

function StoreList() {
  const {
    storeName,
    setStoreName,
    storeAccountType,
    setStoreAccountType,
    kitchenData,
    setkitchenData,
    getKitchenList,
    restaurantList,
    homeChefList,
    cloudKitchenList,
    cuisineList,
    setCuisineList,
    celebrityChefList,
    setCelebrityChefList,
    promotionalKitchenList,
    setPromotionalKitchenList,
    cateringList,
  } = useContext(OnTheMenuDataContext);
  const { isLoggedIn, onCustomerInformationApiHandler, customerInfoData, onLogout, fingerPrint } =
    useContext(LoginDataContext);
  const { OnLoadInformation, onLoadInfoResponse, openLiveOrderTracking, setOpenLiveOrderTracking } =
    useContext(GlobalStateDataContext);
  const { errors, isLoading: loading, data, success } = kitchenData;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const localStorageZipcode = () => localStorage.getItem(ZIP_CODE);
  const localStorageKitchens = () => localStorage.getItem(KITCHEN_NAMES);
  const [activeTab, setActiveTab] = useState('All');

  const [filteredRestaurantList, setFilteredRestaurantList] = useState(restaurantList);
  const [filteredHomeChefList, setFilteredHomeChefList] = useState(homeChefList);
  const [filteredCateringList, setFilteredCateringList] = useState(cateringList);
  const [filterCelebrityChefList, setFilterCelebrityChefList] = useState(celebrityChefList);
  const [filteredCloudKitchenList, setFilteredcloudKitchenList] = useState(cloudKitchenList);

  const triggerLogout = async () => {
    await onLogout();
    navigate('/onthemenu');
    window.location.reload();
  };

  const apiCallCustomerInfo = async () => {
    await onCustomerInformationApiHandler();
  };

  useEffect(() => {
    setIsLoading(true);
  }, []);

  useEffect(() => {
    OnLoadInformation();

    // Do we have kitchenName key and kitchens in local storage before making API call to getKitchenList
    if (!(KITCHEN_NAMES in localStorage) || !localStorageKitchens()) {
      localStorage.clear();
      window.location.reload();
    } else {
      getKitchenList(localStorageKitchens()?.split(','));
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }

    if (isLoggedIn) {
      apiCallCustomerInfo();
    }
  }, []);

  useEffect(() => {
    if (data?.kitchen_count === 0 && kitchenData === null) {
      triggerLogout();
      return;
    }

    setFilteredRestaurantList([...restaurantList]);
    setFilteredHomeChefList([...homeChefList]);
    setFilteredCateringList([...cateringList]);
  }, [data?.kitchen_count]);

  const handleChange = (event, newValue) => {
    if (setActiveTab) {
      if (newValue === 'All') {
        setFilteredRestaurantList([...restaurantList]);
        setFilteredHomeChefList([...homeChefList]);
        setFilteredCateringList([...cateringList]);
      } else {
        setFilteredRestaurantList(restaurantList.filter((obj) => obj.cuisine === newValue));
        setFilteredHomeChefList(homeChefList.filter((obj) => obj.cuisine === newValue));
        setFilteredCateringList(cateringList.filter((obj) => obj.cuisine === newValue));
      }
      setActiveTab(newValue);
    }
  };
  const handleClickRedirect = async (e, kitchen) => {
    setStoreAccountType(kitchen.account_type);
    setStoreName(kitchen.kitchenName);
    await navigate(`/onthemenu/storemenu?storename=${kitchen.kitchenName}`);
  };

  // console.log('---- kitchenData,', kitchenData)
  // console.log('---cuisineList', cuisineList)
  // console.log('----RestaurantList -FIL', filteredRestaurantList)
  // console.log('----HomeChefList- FIL', filteredHomeChefList)
  // console.log('----CloudKitchenList -FIL', filteredCloudKitchenList)
  // console.log('----CateringList -FIL', filteredCateringList)

  // console.log('------restaurantList', restaurantList)
  // console.log('------homeChefList', homeChefList)
  // console.log('------cloudKitchenList', cloudKitchenList)
  // console.log('------cuisineList', cuisineList)

  // We should capture this if block errors in new relic
  if (
    success === false &&
    errors?.CustomMessage === 'Something is seriouly wrong,This is last CATCH block'
  ) {
    return (
      <PageBase>
        <ErrorCatchBlock404 />
      </PageBase>
    );
  }

  if (errors === API_NETWORK_ERROR && success === false) {
    return <Error404 />;
  }

  if (isLoading || loading) return <StoreListSkeleton />;

  if (isMobile) {
    return (
      <>
        <StoreListTabs
          tabNames={['All', ...cuisineList]}
          value={activeTab}
          setValue={setActiveTab}
          onChange={handleChange}
        />
        {filteredRestaurantList?.length >= 1 && (
          <RestaurantsMobile
            filteredRestaurantList={filteredRestaurantList}
            handleClickRedirect={handleClickRedirect}
            customerInfoData={customerInfoData}
          />
        )}
        {filteredHomeChefList?.length >= 1 && (
          <HomeChefsMobile
            filteredHomeChefList={filteredHomeChefList}
            handleClickRedirect={handleClickRedirect}
            customerInfoData={customerInfoData}
          />
        )}
        {celebrityChefList?.length >= 1 && (
          <CelebrityChefMobile
            celebrityChefList={celebrityChefList}
            handleClickRedirect={handleClickRedirect}
            customerInfoData={customerInfoData}
          />
        )}
        {cloudKitchenList?.length >= 1 && (
          <CloudKitchenMobile
            cloudKitchenList={cloudKitchenList}
            handleClickRedirect={handleClickRedirect}
            customerInfoData={customerInfoData}
          />
        )}
        {filteredCateringList?.length >= 1 && (
          <CateringMobile
            filteredCateringList={filteredCateringList}
            handleClickRedirect={handleClickRedirect}
            customerInfoData={customerInfoData}
          />
        )}
      </>
    );
  }

  return (
    <>
      <PageBase>
        <StoreListTabs
          tabNames={['All', ...cuisineList]}
          value={activeTab}
          setValue={setActiveTab}
          onChange={handleChange}
        />
        {openLiveOrderTracking && <OrderTrackingLive />}
        {filteredRestaurantList?.length >= 1 && (
          <Restaurants
            filteredRestaurantList={filteredRestaurantList}
            handleClickRedirect={handleClickRedirect}
            customerInfoData={customerInfoData}
          />
        )}
        {filteredHomeChefList?.length >= 1 && (
          <HomeChefs
            filteredHomeChefList={filteredHomeChefList}
            handleClickRedirect={handleClickRedirect}
            customerInfoData={customerInfoData}
          />
        )}
        {celebrityChefList?.length >= 1 && (
          <CelebrityChef
            celebrityChefList={celebrityChefList}
            handleClickRedirect={handleClickRedirect}
            customerInfoData={customerInfoData}
          />
        )}
        {cloudKitchenList?.length >= 1 && (
          <CloudKitchen
            cloudKitchenList={cloudKitchenList}
            handleClickRedirect={handleClickRedirect}
            customerInfoData={customerInfoData}
          />
        )}
        {filteredCateringList?.length >= 1 && (
          <Catering
            filteredCateringList={filteredCateringList}
            handleClickRedirect={handleClickRedirect}
            customerInfoData={customerInfoData}
          />
        )}
      </PageBase>
      <Outlet />
    </>
  );
}

export default Transition(StoreList);
